export const ItemTypes = {
    CHOICE: 'choice',
}